import IconButton, { IconButtonType } from '../components/IconButton';
import LabelButton from '../components/LabelButton';
import { PHShape } from '../plugins/global/PlaceholderPlugin';
import { evenlyDistributeHorizontally, evenlyDistributeVertically } from '../plugins/utils/Utils';
import BaseScene from './BaseScene';

/**
 *
 * @category scenes
 * @export
 * @class SpongeExamplesScene
 * @extends {BaseScene}
 */
export default class SpongeExamplesScene extends BaseScene {

  phaser3d: any;
  mixers: any[] = [];

  constructor() {
    super({
      key: "SpongeExamplesScene",
      active: false, // false means this state isn't loaded on boot. true means its instantly activated.
    });
    console.log("SpongeExamplesScene::constructor");
  }

  preload(): void {
    super.preload();
    console.log("SpongeExamplesScene::preload");
  }



  create(): void {
    // when scene is first loaded.
    console.log("SpongeExamplesScene::create");

    


    //this.physics.add.staticGroup();
    // this.testProgressBar();
    // this.testUIAndPlaceholders();
    // this.showTrackingTestOptions();
    // this.test3d();
    // this.testBanking();
    // this.ShowAvaliblePopups();
    // this.testDragAndDrop();
    this.testOverlayingScene();

    //this.testDistributionMethods();




  }

  private testDistributionMethods(): void {
    const items: Phaser.GameObjects.Image[] = [];

    // gen some boys
    for (let i = 0; i < 4; i++) {
      items.push(this.sponge.placeholder.image(this, this.cameras.main.width / 2, 0, PHShape.RECT, { height: 100, width: 200, radius: 0 }, 0xFFFFFF));
    }

    // test disribution
    evenlyDistributeVertically(items, 0, this.cameras.main.height, true);
    evenlyDistributeHorizontally(items, 0, this.cameras.main.width, false);

  }

  private _draggable!: Phaser.GameObjects.Image;

  private testDragAndDrop(): void {


    // for draggin and dropping we now use `dropZones`:
    const leftZone = this.sponge.placeholder.image(this, this.game.config.width as number / 4, this.game.config.height as number / 2, PHShape.RECT, {
      width: 300,
      height: 300,
      radius: 20
    }, 0x00FFAA);
    leftZone.alpha = 0.3;
    leftZone.setInteractive();
    leftZone.input.dropZone = true;

    // setting data is a way we can add meta to a game object that is not defined / typed in an objects properties.
    leftZone.setData("id", "left");

    // for draggin and dropping we now use `dropZones`:
    const rightZone = this.sponge.placeholder.image(this, this.game.config.width as number / 4 * 3, this.game.config.height as number / 2, PHShape.RECT, {
      width: 300,
      height: 300,
      radius: 20
    }, 0xAAff00);
    rightZone.alpha = 0.3;
    rightZone.setInteractive();
    rightZone.input.dropZone = true;
    rightZone.setData("id", "right");


    this._draggable = this.sponge.placeholder.image(this, this.game.config.width as number / 2, this.game.config.height as number / 2, PHShape.RECT, {
      width: 150,
      height: 150,
      radius: 20
    }, 0xff00AA);
    // set interactive and draggable
    this._draggable.setInteractive();
    this.input.setDraggable(this._draggable);


    // just the two above dont actually make the object draggable,
    // we have to set up the events for these objects to correct give the dragging effect.
    this.input.on("dragstart", (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Image) => {
      console.log(`drag start: ${pointer.x} x ${pointer.y}, ${gameObject.texture.key}`);

    });

    this.input.on('drag', (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Image, dragX: number, dragY: number) => {
      // just move the dragging items
      gameObject.x = dragX;
      gameObject.y = dragY;
    });

    // when dragging an item and we enter a zone
    this.input.on('dragenter', (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Image, dropZone: Phaser.GameObjects.Image) => {
      console.log(`entering zone: ${dropZone.getData("id")} `);
      dropZone.alpha = 1;
    });

    // when dragging an item and we leave a zone
    this.input.on('dragleave', (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Image, dropZone: Phaser.GameObjects.Image) => {
      console.log(`leaving zone: ${dropZone.getData("id")} `);
      dropZone.alpha = 0.3;

    });

    // when released over a defined zone.
    this.input.on('drop', (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Image, dropZone: Phaser.GameObjects.Image) => {

      gameObject.x = dropZone.x;
      gameObject.y = dropZone.y;
      gameObject.input.enabled = false;

      // add the id of the dropzone to the draggable item, we may wish to itterate over these when we are complete to determine score
      gameObject.setData("chosenID", dropZone.getData("id"));
      dropZone.alpha = 0.3;

    });

    // when we stop dragging this item
    this.input.on('dragend', (pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.Image, dropped: boolean) => {

      if (!dropped) {
        gameObject.x = gameObject.input.dragStartX;
        gameObject.y = gameObject.input.dragStartY;
      }

    });

  }


  private ShowAvaliblePopups(): void {
    // itterate and show all out popups
    let i = 40;
    for (const item in this.sponge.data.model.content.popups) {
      new LabelButton(this, (this.game.config.width as number) - 100, i, item + " popup", () => {
        this.sponge.popup.launchPopup(item, () => {
          console.log("popup dismissed");
        });
      });
      i += 60;
    }
  }



  private testBanking(): void {
    console.log("Group 1");
    // request 3 "questions" from the ContentModel
    console.log(this.sponge.data.generateBankOfQuestions(3));
    console.log("Group 2");
    // request 3 more "Questions" from the ContentModel (different to the above.)

    console.log(this.sponge.data.generateBankOfQuestions(3));
    console.log("Group 3");
    // you can mix amounts.

    console.log(this.sponge.data.generateBankOfQuestions(4));
    console.log("Group 4");

    // this will be undefined if we do not have enough items to create the amount reqested
    console.log(this.sponge.data.generateBankOfQuestions(3));

    this.sponge.data.resetBankOfItems("questions"); // we can reset the banking counter here as to start getting repeat questions again.
    console.log("Group 1 - after reset");

    // request 3 "questions" from the ContentModel where the catergory property === cat1
    console.log(this.sponge.data.generateBankOfQuestions(3, { _category: "cat1" }));

    // request 1 "questions" from the ContentModel where the catergory property === cat3 and the property "anotherTag" is true;
    console.log(this.sponge.data.generateBankOfQuestions(1, { _category: "cat3", _difficulty: 1 }));

    // request 5 "questions" from the ContentModel where the catergory property === cat1 - will cause an error as previous request has request most of cat1
    console.log(this.sponge.data.generateBankOfQuestions(4, { _category: "cat1" }));
  }

  private testUIAndPlaceholders(): void {
    // label button with callback
    new LabelButton(this, 100, 100, "hi", () => { console.log("click"); }),

      // icon button with toggle callback
      new IconButton(this, 100, 200, (toggle: boolean | undefined) => { console.log("icon click", toggle); }, IconButtonType.SOUND);


    // placeholder tools (image if we are using this as a static object)
    this.sponge.placeholder.image(this, 300, 400, PHShape.RECT, {
      width: 150,
      height: 400,
      radius: 20
    }, 0xff00AA);

    // sprite for when we want to use animation in the future
    this.sponge.placeholder.sprite(this, 500, 400, PHShape.CIRCLE, {
      radius: 50,
      width: 100,
      height: 100
    }, 0x00FFAA);

    // phyiscs for an Arcade Physics sprite.
    const physicsTest = this.sponge.placeholder.physics(this, 700, 400, PHShape.ROUND_RECT, {
      width: 100,
      height: 200,
      radius: 10,
    }, 0xAAFF00);

    // phyiscs is enabled (and global setting like gravity) are set in the main index config.
    physicsTest.setBounce(0.2);
    physicsTest.setCollideWorldBounds(true);

    // allow drag of our physics object
    physicsTest.setInteractive();

    physicsTest.on("pointerdown", () => {
      physicsTest.setVelocityY(-400);
    });

  }

  private test3d(): void {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore    
    this.phaser3d = new Phaser3D(this, { x: -5.18, y: 0.74, z: 2.92 });

    this.phaser3d.addGLTFModel('model');

    //  Parsing happens asynchronously, so listen out for the event, or provide an onload handler
    this.phaser3d.on('loadgltf', (gltf: any, model: any) => {

      // model.rotateY(Math.PI);
      model.position.set(0, 0, 0);

      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore    
      const mixer = new THREE.AnimationMixer(model);

      this.mixers.push(mixer);

      const action = mixer.clipAction(gltf.animations[0]);
      action.play();
    });


    this.phaser3d.add.hemisphereLight({ skyColor: 0xffffff, groundColor: 0x111111, intensity: 2 });

    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore    

    new THREE.OrbitControls(this.phaser3d.camera, this.scale.parent);

    this.phaser3d.camera.rotation.set(-0.25, -1.04, -0.22);
  }

  private testOverlayingScene(){
    // here we will add a new overlaying scene over this one so they run in parallel, when we close the new scene
    // it will trigger a callback event so we know it's finished with and this scene will remove it

    // placeholder tools (image if we are using this as a static object)
    const bg = this.add.graphics({x:0, y:0});
    bg.fillStyle(0x990000,1);
    bg.fillRect(200,200,this.cameras.main.width - 400, this.cameras.main.height - 400)

    this.add.text(this.cameras.main.centerX, this.cameras.main.centerY + 180,"MAIN SCENE",this.sponge.data.model.fonts.h1).setAlign("center").setFill("#FFFFFF").setOrigin(0.5);

    // Add a listener to the scene close callback
    this.scene.get("OverlayScene").events.on("overlayClosed", this.removeOverlayingScene, this);

    console.log("launchOverlayingScene")

    this.scene.run("OverlayScene");
    this.scene.bringToTop("OverlayScene");

    
  }

  private removeOverlayingScene(){
    console.log("removeOverlayingScene")
    this.scene.stop("OverlayScene");
    
  }

  update(time: number, delta: number): void {
    super.update(time, delta);

    // update animation mixer
    this.mixers.forEach((mixer) => { mixer.update(delta / 1000); });


  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  benchmarking(): void {

  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  render(): void {


  }

  wake(): void {
    // when the scene has previously been "sleeped" this is called instead of create when re-visiting

  }
  sleep(): void {
    // when switching away from this scene to another.
  }

  shutdown(): void {
    // drop references to anything we have in create
    super.shutdown();
  }
}
